export async function addBlankDiv (className, target) {
  if (document.querySelector(`.${className}`) === null) {
    const div = document.createElement('div')
    div.className = className
    if (target) {
      document.querySelector(target).appendChild(div)
    } else {
      document.body.appendChild(div)
    }

    return document.querySelector(`.${className}`)
  }
}
